// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc701bfb","239":"8842cf4e","455":"f6f7feab","493":"1b9ed1f2","732":"dc1c0416"}[chunkId] + ".chunk.js";
};